import React from 'react'
import { ICustomChipView } from './interfaces'
import { CustomChipView } from './CustomChipView'

export const CustomChip: React.FC<ICustomChipView> = ({ type, content, active, onRemove, changeStatus }) => {
  return (
    <CustomChipView type={type} content={content} active={active} onRemove={onRemove} changeStatus={changeStatus} />
  )
}
